import gsap, {Power2, Power3} from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export class SectionOfferModule{

    constructor() {
    }

    init(){
        if(window.innerWidth < 1023) return;

        const circle = document.querySelector('.circle__animation');
        const items = document.querySelectorAll('.section__offer .vertical__image__item');
        gsap.set(circle,{scale:0.6})
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".section--header",
                start: 'top top',
                end: "+=700",
                scrub: true,
            }
        });
        tl.from(circle, {y: -900,x: 550,duration: 14,force3D:true});
        tl.to(document.querySelector('.circle__animation #kbj'), {duration: 1,opacity: 0})
        tl.to(document.querySelector('.circle__animation #offer'), {duration: 1,opacity: 1})
        // tl.from(items, {opacity:0,stagger:1.5,duration: 1,delay:-8,force3D:true});
        tl.from(items, {opacity:0,stagger:1.2,duration: 1.4,force3D:true}, '-=7');
        // tl.to(circle, {scale:0.8,duration: 2,force3D:true});
        // tl.to(circle, {scale:0.8,duration: 2,delay: -4,force3D:true});
        tl.to(circle, {scale:1.25,duration: 2,force3D:true}, '-=3');
        // const tl2 = gsap.timeline({
        //     scrollTrigger: {
        //         trigger: "#text__animation",
        //         start: "-500px", // When the top of the trigger reaches the top of the viewport
        //         end: 'top',
        //         markers: true,
        //         scrub: true,
        //     }
        // });
        // tl2.from(document.querySelector('#text__animation h3'), {scale:300,duration:2});

    }



}
